module.exports = __webpack_public_path__ + "media/wave_solder_pallets/hold-downs-faef0311.png";